export enum ContentTypes {
  EditorialPage = 'editorialPage',
  CategoryPage = 'categoryPage',
  Widget = 'widget',
  UiAction = 'uiAction',
  ArticlePage = 'articlePage',
}
